export default __webpack_public_path__ + "static/media/item-item.2e850b5d.png";